import { FC } from "react"
import Badge from "../../../../badge"
import Tooltip from "../../../../tool-tip"

interface Props {
  className?: string
  pricingStatus: number
}

const PricingStatusBadge: FC<Props> = ({ className, pricingStatus }) => {
  if (pricingStatus !== 1) return null

  return (
    <Tooltip
      toolTipNode={
        <Badge.Danger className={className}>Pricing failed</Badge.Danger>
      }
      placement="top"
      text="Last pricing attempt failed"
    />
  )
}

export default PricingStatusBadge
